import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/zoyaspantry.com.au/httpdocs/frontend/src/app/cart/CartTemplate.js");
